<template>
  <div class="d-flex" style="background: #EEECF1;">
    <div class="preview position-relative u-scrollbar-hidden" style="background: #FFFFFF; overflow-y: scroll;">
      <div class="m-auto w-100">
        <div class="d-flex flex-column align-items-center">
          <div class="fw-bold"><p>{{ getTitleText }}</p></div>

          <div class="d-flex" style="gap: 8px;">
            <div class="position-relative cursor-pointer" style="width: 100px; height: 40px;" @click="onClickReturnBtn()">
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="40" viewBox="0 0 100 40" fill="none">
              <path d="M17.668 1H97C98.1046 1 99 1.89543 99 3V37C99 38.1046 98.1046 39 97 39H17.668C17.0655 39 16.495 38.7284 16.1152 38.2607L2.31152 21.2607C1.71513 20.5262 1.71513 19.4738 2.31152 18.7393L16.1152 1.73926C16.495 1.27158 17.0655 1 17.668 1Z" fill="white" stroke="#8C9BC6" stroke-width="2"/>
              </svg>
              <div class="position-absolute fw-bold" style="font-size: 16px; color: #8C9BC6; top: 8px; left: 32px;">もどる</div>
            </div>

            <div class="preview-area border border-1 border-dark" :style="getCanvasSize">
              <DesignPreview />
            </div>

            <div class="d-flex flex-column justify-content-end" style="width: 243px; gap: 8px;">
              <IsShowCutline />
              <PreviewMode />
              <button class="preview-btn" @click="resetCamera">
                元の位置に戻す
              </button>
            </div>

          </div>
        </div>

        <Precautions>
          <p class="m-0">・プレビュー上でのカットラインは半透明で表現しています。</p>
          <p class="m-0">・プレビューによるデザインとカットラインを元に制作いたします。</p>
          <p class="m-0">・カットラインが正しく作成されていないと製造ができませんのでご注意ください。</p>
          <p class="m-0">・カットラインとデザインが交わっている箇所はプリントが剥がれやすくなります。</p>
          <p class="m-0">・アタッチメントのつけ忘れ、5mm以下の小さなパーツは再現性の低下や破損に繋がります。また保証対象外となりますのでご注意ください。</p>
        </Precautions>

        <!-- チュートリアル用3 -->
        <!-- <div class="nonEditable-modal d-flex flex-column m-auto" style="padding: 24px 48px;"
        v-if="this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 3">
          <div style="font-size: 28px; color: #595959; font-weight: 700; padding-bottom: 10px;">
            編集禁止領域について
          </div>

          <div class="d-flex flex-column u-scrollbar-hidden" style="widht: 673px; padding-top: 10px; gap: 24px; overflow-y: scroll;">
            <p class="text-start mt-1">アクリルデザインの一部に編集禁止領域を設ける事で、デザインを守る事が可能になります。</p>

            <div>
              <div style="border-radius: 20px; background: #B1C0DB; width: 190px; height: 30px; color: #FFFFFF; font-weight: 700; padding-top: 2px;">
                <p>編集禁止領域とは？</p>
              </div>
              <p class="text-start m-0">アクリルデザインの特定の場所を指定することで、チケット使用者が編集する事が出来なくなります。</p>
              <p class="text-start m-0">（下図の赤色の箇所が編集出来ない領域として設定する事ができます。）</p>
            </div>

            <img style="height: 263px; object-fit: contain;" src="@/assets/acrypro/coupon/nonEditable_info1.png" />
            <img style="height: 145px; object-fit: contain;" src="@/assets/acrypro/coupon/nonEditable_info2.png" />
          </div>

          <button class="border-0 bg-transparent position-absolute" style="top: 10px; right: 10px;" @click="hideModel()">
            <img src="@/assets/acrypro/close.svg">
          </button>

        </div> -->
      </div>
    </div>
    <div class="p-0" style="width: 330px; margin-right: -32px; overflow: hidden;">
      <div class="row m-0 mx-2 right-menu">
        <RightMenuEventImageUpload />
      </div>
    </div>
  </div>
</template>

<script>
import {
  ProductId,
  GetCanvasSize,
  RightViewState,
} from "@/js/Const.js";

import RightMenuEventImageUpload from "@/components/acyrpro/ticket/RightMenuEventImageUpload_Ap.vue";
import IsShowCutline from "@/components/acyrpro/preview/IsShowCutline.vue";
import PreviewMode from "@/components/acyrpro/preview/PreviewMode.vue";
import DesignPreview from "@/components/acyrpro/preview/DesignPreview.vue";
import Precautions from "@/components/acyrpro/preview/Precautions.vue";


export default {
  name: "CenterViewEventDesignUpload_Ap",
  props: {},
  components: {
    RightMenuEventImageUpload,
    IsShowCutline,
    PreviewMode,
    DesignPreview,
    Precautions,
  },
  data: function () {
    return {

    };
  },
  computed: {
    getProductId(){
      switch(this.$store.state.eventCreateData.selectSize){
        case "S": return ProductId.S_SVG;
        case "M": return ProductId.M_SVG;
        case "L": return ProductId.L_SVG;
        default: return 0;
      }
    },
    getCanvasSize(){
      let canvasSize = GetCanvasSize(this.getProductId);
      return {
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
        };
    },
    getTitleText(){
      switch(this.$store.state.eventCreateData.selectSize){
        case "S": return "Sサイズ";
        case "M": return "Mサイズ";
        case "L": return "Lサイズ";
        default: return "";
      }
    },
  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");
    this.$store.commit("setIsCenterViewScroll", false);

    this.$store.commit("showLoading");

    await this.$store.state.acrylicTicketCouponManager.update().catch((e) => {
      this.$handleError("034", e, { hideLoading: true });
    });

    this.$store.commit("hideLoading");
  },
  methods: {
    onClickReturnBtn(){
      this.$store.commit("setIsCenterViewScroll", true);
      this.$store.commit("setRightViewState", RightViewState.Cart);
      this.$store.commit("setPreviousCenterViewState");
    },
    hideModel(){
      this.$store.commit("hidePreviewTutorial");
    },
    resetCamera(){
      if( this.$store.state.resetCameraFunc ) this.$store.state.resetCameraFunc();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.preview{
  // max-width: 805px;
  width: 100%;
  padding: 16px 32px;
  height: calc(100vh - #{$header-height});
}

.control-area{
  margin-left: 16px;
  width: 243px;
}

.design {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.cutLine {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  opacity: 0.3;
}

.nonEditable {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.5;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.nonEditable-modal{
  position: fixed;
  height: 80%;
  max-height: 742px;
  width: 750px;
  z-index: 3;
  background: white;
  border-radius: 4px;

  top: 10%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);

  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}
.preview-btn{
  height: 40px;
  margin-top: 8px;
  font-weight: bold;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 4px;
  background-color: $background-white-color;
}

.right-menu{
  background-color: $background-white-color;
  height: calc(100vh - #{$header-height});
  width: 284px;
}
</style>
